
import styled from "styled-components"
import { useSelector } from "react-redux"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useState } from "react"
import { useDispatch } from "react-redux"
import {getAracTypes, getKasaTypes } from "../../features/adminSett/adminSettSlice"
import { useEffect } from "react"

const Container = styled.div`
    width: 100%;

.wrapper{
  display: flex;
  flex-direction: column;

    .content{
      padding: 40px;
      display: flex;
      justify-content: space-between;
      gap: 40px;
    }
}
`

const AracKasaTypes = () => {
    const {} = useSelector(state => state.admin)
    const dispatch = useDispatch()
  
    const [value, setValue] = useState("")


    useEffect(() => {
        dispatch(getAracTypes())
        dispatch(getKasaTypes())
    },[])


    const handleChange = (e) => {
        setValue(e.target.value)
    }

  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Araç ve Kasa Tipleri"} position='sticky'/>

      <div className="content">
        <input type="text" value={value} onChange={handleChange} />

      </div>
    </div>
    </Container>
  )
}

export default AracKasaTypes